import React, { Suspense } from 'react';
import { memberId } from '@trello/session-cookie';
import { useLazyComponent } from '@trello/use-lazy-component';
import { HeaderSkeleton } from 'app/src/components/HeaderSkeleton';
import styles from './Header.less';

export const Header = () => {
  const HeaderContainerWithProviders = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "header" */ 'app/src/components/Header/HeaderContainer'
      ),
    { namedImport: 'HeaderContainerWithProviders' },
  );

  const headerStyles = !memberId ? styles.loggedOutHeader : styles.header;

  return (
    <div
      data-desktop-id="header"
      // needed for hiding the header in madlibs and moonshot
      // create-first-board and create-first-team
      data-js-id="header-container"
      className={headerStyles}
    >
      <Suspense fallback={<HeaderSkeleton />}>
        <HeaderContainerWithProviders />
      </Suspense>
    </div>
  );
};
